import React, { useState } from 'react';
import { Grid, Typography, Button, Dialog } from '@mui/material';
import './ScheduleDemoSection.css';
import LogoTopLeft from "../../assests/Pages/CallAnalysis/left_top.png";
import LogoBottomRight from  "../../assests/Pages/CallAnalysis/btm_right.png";
import BookACalendlyDialog from '../../Utils/GlobalDialog/BookACalendlyDialog/BookACalendlyDialog';

const ScheduleDemoSection = () => {
  const [flagOpenBookaMeetingDemo, setFlagOpenBookaMeetingDemo] = useState(false);
  
  return (
    <Grid container className="schedule-demo-main-container" justifyContent="center">
        <Grid item xs={12} sm={11} md={11} lg={9} xl={9} className="small-padding">
            <div className="schedule-demo-content-container">
                <img src={LogoBottomRight} alt="Top Left Decoration" className="schedule-demo-logo top-left" />

                <img src={LogoTopLeft} alt="Bottom Right Decoration" className="schedule-demo-logo bottom-right" />

                <Grid container direction="column" alignItems="center">
                  <Grid item xs={12}>
                      <Grid container justifyContent={"center"} gap={5}>
                        <Grid item xs={12} sm={11} md={11} lg={11} xl={10}>
                            <Typography className="schedule-demo-text">
                              This powerful feature is exclusively available after scheduling a meeting with our team. 
                              Book a session now to explore how AI-powered Call Analysis can benefit your business.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} className="schedule-demo-button-container">
                          <Button 
                            className="schedule-demo-button" 
                            aria-label='Schedule a Demo'
                            onClick={() => setFlagOpenBookaMeetingDemo(true)}
                          >
                            Schedule a Demo
                          </Button>
                        </Grid>
                      </Grid>
                  </Grid>
                </Grid>
            </div>

            {
                flagOpenBookaMeetingDemo &&
                <Dialog open={flagOpenBookaMeetingDemo}
                    maxWidth='lg'
                    sx={{ '&.MuiPaper-root': { width: '100%' } }}
                    className="iframe-dialog"
                >
                    <BookACalendlyDialog
                        flagOpenBookaMeetingDemo={flagOpenBookaMeetingDemo}
                        setFlagOpenBookaMeetingDemo={setFlagOpenBookaMeetingDemo}
                    />
                </Dialog>
            }
        </Grid>
    </Grid>
  );
};

export default ScheduleDemoSection;
